// WordPress dependencies
import { PanelBody, PanelRow, RangeControl, SelectControl, Tooltip } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import ImagePicker from "../elements/image-picker";
import ProFeatureControl from "../elements/pro-feature-control";
import ToggleSwitch from "../elements/ToggleSwitch";

const coreAssets = window.COCA_BAIS_ASSETS;

export default (props) => {
    const isTripleEnabled = !!props.proSettings.is_triple_active;
    const sliderType = props.attributes.slider_type;
    const isTriple = isTripleEnabled && sliderType === "triple";
    const OffsetField = (
        <div className={"field-control field-inline"}>
            <span className="field-control__label">{__("Divider Default Offset", "wp-before-after-image-slider")}</span>
            <div className={"fields-wrapper inline"}>
                <RangeControl
                    initialPosition={50}
                    trackColor="#4A25E1"
                    railColor="#603CFF7A"
                    max={100}
                    min={0}
                    value={parseInt(props.attributes.default_offset)}
                    onChange={(value) => props.updateAttributes({ default_offset: value })}
                />
                {!!props.proFeatureEnabled ? null : (
                    <img
                        src={coreAssets.icons.premium}
                        alt="Premium Icon"
                        // style={{ marginLeft: "-26px", marginTop: "-4px" }}
                    />
                )}
            </div>
        </div>
    );

    return (
        <PanelBody
            title={__("Settings", "wp-before-after-image-slider")}
            initialOpen={false}
            opened={props.attributes.settings_panel_open}
            onToggle={() =>
                props.updateAttributes({
                    settings_panel_open: !props.attributes.settings_panel_open,
                })
            }
        >
            <PanelRow>
                {!isTriple && (
                    <>
                        <ProFeatureControl {...props} value={"default_offset"}>
                            {OffsetField}
                        </ProFeatureControl>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Trigger Type", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <SelectControl
                                    className="large-select"
                                    value={props.attributes.trigger_type || "drag"}
                                    onChange={(value) =>
                                        props.updateAttributes({
                                            trigger_type: value,
                                        })
                                    }
                                    options={[
                                        { label: __("Drag", "wp-before-after-image-slider"), value: "drag" },
                                        { label: __("Hover", "wp-before-after-image-slider"), value: "hover" },
                                    ]}
                                />
                            </div>
                        </div>
                    </>
                )}
                <div className="field-control__grid__label_field ">
                    {/* <div className={"field-control field-inline"}>
                        <span className="field-control__label">
                            {__("Show Overlay", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <ToggleSwitch
                                initialValue={props.attributes.show_overlay || false}
                                onChange={(value) =>
                                    props.updateAttributes({
                                        show_overlay: value,
                                    })
                                }
                            />
                        </div>
                    </div> */}
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">
                            {__("Show Overlay", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <ToggleSwitch
                                initialValue={props.attributes.show_overlay || false}
                                onChange={(value) => props.updateAttributes({ show_overlay: value })}
                            />
                        </div>
                    </div>
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">
                            {__("Show Labels", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <SelectControl
                                className="large-select"
                                value={props.attributes.show_labels === '1' ? "label_always_show" : (props.attributes.show_labels || "label_always_show")}
                                onChange={(value) =>
                                    props.updateAttributes({
                                        show_labels: value,
                                    })
                                }
                                options={[
                                    { label: __("Hide", "wp-before-after-image-slider"), value: "label_hide" },
                                    { label: __("Always Show", "wp-before-after-image-slider"), value: "label_always_show" },
                                    { label: __("Show on Hover", "wp-before-after-image-slider"), value: "label_show_on_hover" },
                                ]}
                            />
                        </div>
                    </div>
                    <div className={"field-control field-inline"}>
                        <span className="field-control__label">
                            {__("Lazy Load", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <ToggleSwitch
                                initialValue={props.attributes.lazy_load !== undefined ? props.attributes.lazy_load : true}
                                onChange={(value) => props.updateAttributes({ lazy_load: value })}
                            />
                        </div>
                    </div>
                    <ProFeatureControl {...props} value={"badge_enabled"}>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Badge / Watermark", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                {(() => {
                                    const badgeMode = (window.COCA_BAIS_ASSETS && window.COCA_BAIS_ASSETS.global_badge_mode) || 'per_slider';
                                    if (badgeMode === 'force_off' || badgeMode === 'force_on') {
                                        const tooltipText = badgeMode === 'force_off'
                                            ? __("Badge is forcefully disabled for all sliders. Change in Settings → Badge.", "wp-before-after-image-slider")
                                            : __("Badge is forcefully enabled for all sliders. Change in Settings → Badge.", "wp-before-after-image-slider");
                                        return (
                                            <Tooltip text={tooltipText}>
                                                <span tabIndex={0} style={{ display: 'inline-block', opacity: 0.5 }}>
                                                    <span style={{ display: 'inline-block', pointerEvents: 'none' }}>
                                                        <ToggleSwitch
                                                            initialValue={badgeMode === 'force_on'}
                                                            onChange={() => {}}
                                                        />
                                                    </span>
                                                </span>
                                            </Tooltip>
                                        );
                                    }
                                    return (
                                        <ToggleSwitch
                                            initialValue={!!props.attributes.badge_enabled}
                                            onChange={(value) => props.updateAttributes({ badge_enabled: value })}
                                        />
                                    );
                                })()}
                                {!!props.proFeatureEnabled ? null : (
                                    <img
                                        src={coreAssets.icons.premium}
                                        alt="Premium Icon"
                                        style={{ marginTop: "-4px" }}
                                    />
                                )}
                            </div>
                        </div>
                    </ProFeatureControl>
                </div>

                {!isTriple && (
                    <>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Slider Orientation", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <ImagePicker
                                    options={[
                                        {
                                            value: "horizontal",
                                            label: __("Vertical", "wp-before-after-image-slider"),
                                            imageUrl: coreAssets.orientation.hr,
                                        },
                                        {
                                            value: "vertical",
                                            label: __("Horizontal", "wp-before-after-image-slider"),
                                            imageUrl: coreAssets.orientation.vr,
                                        },
                                        {
                                            value: "diagonal",
                                            label: __("Diagonal", "wp-before-after-image-slider"),
                                            imageUrl: coreAssets.orientation.dg,
                                        },
                                    ]}
                                    value={props.attributes.orientation || "horizontal"}
                                    onChange={(value) =>
                                        props.updateAttributes({
                                            orientation: value,
                                        })
                                    }
                                    isProFeature={false}
                                    showLabel={true}
                                />
                            </div>
                        </div>
                        {props.attributes.orientation === "diagonal" && (
                            <div className={"field-control field-inline"}>
                                <span className="field-control__label">
                                    {__("Diagonal Direction", "wp-before-after-image-slider")}
                                </span>
                                <div className={"fields-wrapper inline"}>
                                    <SelectControl
                                        className="large-select"
                                        value={props.attributes.diagonal_direction || "backslash"}
                                        onChange={(value) =>
                                            props.updateAttributes({ diagonal_direction: value })
                                        }
                                        options={[
                                            {
                                                label: __("Top-left \u2192 Bottom-right ( \\\ )", "wp-before-after-image-slider"),
                                                value: "backslash",
                                            },
                                            {
                                                label: __("Top-right \u2192 Bottom-left ( / )", "wp-before-after-image-slider"),
                                                value: "slash",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}

                {/* <ProFeatureControl {...props} value={"slider_template"}> */}
                <div className={"field-control field-inline"}>
                    <span className="field-control__label">
                        {__("Slider Template", "wp-before-after-image-slider")}
                    </span>
                    <div className={"fields-wrapper inline"}>
                        <ImagePicker
                            options={[
                                {
                                    value: "default",
                                    label: "default",
                                    imageUrl: coreAssets.templates.st01,
                                },
                                {
                                    value: "style01",
                                    label: "Item 1",
                                    imageUrl: coreAssets.templates.st02,
                                },
                                {
                                    value: "style02",
                                    label: "Item 2",
                                    imageUrl: coreAssets.templates.st03,
                                },
                                {
                                    value: "style03",
                                    label: "Item 3",
                                    imageUrl: coreAssets.templates.st04,
                                },
                                {
                                    value: "style04",
                                    label: "Item 4",
                                    imageUrl: coreAssets.templates.st05,
                                },
                                {
                                    value: "style05",
                                    label: "Item 5",
                                    imageUrl: coreAssets.templates.st06,
                                },
                                {
                                    value: "style06",
                                    label: "Item 6",
                                    imageUrl: coreAssets.templates.st07,
                                },
                                {
                                    value: "style07",
                                    label: "Item 7",
                                    imageUrl: coreAssets.templates.st08,
                                },
                            ]}
                            value={props.attributes.slider_template || "default"}
                            onChange={(value) =>
                                props.updateAttributes({
                                    slider_template: value,
                                })
                            }
                            isProFeatureEnabled={!!props.proFeatureEnabled}
                            isProFeature={true}
                        />
                    </div>
                </div>
                {/* </ProFeatureControl> */}

                {(sliderType === "default" || sliderType === "retouch") && (
                    <ProFeatureControl {...props} value={"slider_template"}>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Show Popup", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <ToggleSwitch
                                    initialValue={props.attributes.show_popup || false}
                                    onChange={(value) =>
                                        props.updateAttributes({
                                            show_popup: value,
                                        })
                                    }
                                />
                                {!!props.proFeatureEnabled ? null : (
                                    <img
                                        src={coreAssets.icons.premium}
                                        alt="Premium Icon"
                                        style={{ marginTop: "-4px" }}
                                    />
                                )}
                            </div>
                        </div>
                        {props.attributes.show_popup && (
                            <div className={"field-control field-inline"}>
                                <span className="field-control__label">
                                    {__("Popup Position", "wp-before-after-image-slider")}
                                </span>
                                <div className={"fields-wrapper inline"}>
                                    <SelectControl
                                        className="large-select"
                                        value={props.attributes.popup_position}
                                        onChange={(value) =>
                                            props.updateAttributes({
                                                popup_position: value,
                                            })
                                        }
                                        options={[
                                            {
                                                label: __("Top Left", "wp-before-after-image-slider"),
                                                value: "top-left",
                                            },
                                            {
                                                label: __("Top Right", "wp-before-after-image-slider"),
                                                value: "top-right",
                                            },
                                            {
                                                label: __("Bottom Left", "wp-before-after-image-slider"),
                                                value: "bottom-left",
                                            },
                                            {
                                                label: __("Bottom Right", "wp-before-after-image-slider"),
                                                value: "bottom-right",
                                            },
                                        ]}
                                    />
                                </div>
                            </div>
                        )}
                    </ProFeatureControl>
                )}

                {sliderType === "video" ? (
                    <>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Video Control", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <div style={{ width: "100%" }}>
                                    <div className={"field-control field-inline"}>
                                        <span className="field-control__label">
                                            {__("Loop Video", "wp-before-after-image-slider")}
                                        </span>
                                        <div className={"fields-wrapper inline"}>
                                            <ToggleSwitch
                                                initialValue={props.attributes.video_loop || false}
                                                onChange={(value) => {
                                                    console.log("Setting video_loop:", value);
                                                    props.updateAttributes({ video_loop: value });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: "100%" }}>
                                    <div className={"field-control field-inline"}>
                                        <span className="field-control__label">
                                            {__("Auto Play", "wp-before-after-image-slider")}
                                        </span>
                                        <div className={"fields-wrapper inline"}>
                                            <ToggleSwitch
                                                initialValue={props.attributes.video_autoplay || false}
                                                onChange={(value) => {
                                                    console.log("Setting video_autoplay:", value);
                                                    props.updateAttributes({ video_autoplay: value });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}

                {/* Auto Slide Controls for Default, Video, and Retouch Sliders */}
                {(sliderType === "default" || sliderType === "video" || sliderType === "retouch") && (
                    <ProFeatureControl {...props} value={"auto_slide_enabled"}>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Auto Slide", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <ToggleSwitch
                                    initialValue={props.attributes.auto_slide_enabled || false}
                                    onChange={(value) =>
                                        props.updateAttributes({
                                            auto_slide_enabled: value,
                                        })
                                    }
                                />
                                {!!props.proFeatureEnabled ? null : (
                                    <img
                                        src={coreAssets.icons.premium}
                                        alt="Premium Icon"
                                        style={{ marginTop: "-4px" }}
                                    />
                                )}
                            </div>
                        </div>

                        {props.attributes.auto_slide_enabled && (
                            <>
                                <div className={"field-control field-inline"}>
                                    <span className="field-control__label">
                                        {__("Animation Duration (seconds)", "wp-before-after-image-slider")}
                                    </span>
                                    <div className={"fields-wrapper inline"}>
                                        <RangeControl
                                            initialPosition={4}
                                            trackColor="#4A25E1"
                                            railColor="#603CFF7A"
                                            max={10}
                                            min={1}
                                            step={0.5}
                                            value={parseFloat(props.attributes.auto_slide_duration) || 4}
                                            onChange={(value) => props.updateAttributes({ auto_slide_duration: value })}
                                        />
                                    </div>
                                </div>

                                <div className={"field-control field-inline"}>
                                    <span className="field-control__label">
                                        {__("Direction", "wp-before-after-image-slider")}
                                    </span>
                                    <div className={"fields-wrapper inline"}>
                                        <SelectControl
                                            className="large-select"
                                            value={props.attributes.auto_slide_direction || "back_and_forth"}
                                            onChange={(value) =>
                                                props.updateAttributes({
                                                    auto_slide_direction: value,
                                                })
                                            }
                                            options={[
                                                { label: __("Left to Right", "wp-before-after-image-slider"), value: "left_to_right" },
                                                { label: __("Right to Left", "wp-before-after-image-slider"), value: "right_to_left" },
                                                { label: __("Back and Forth", "wp-before-after-image-slider"), value: "back_and_forth" },
                                            ]}
                                        />
                                    </div>
                                </div>

                                <div className={"field-control field-inline"}>
                                    <span className="field-control__label">
                                        {__("Pause on Hover", "wp-before-after-image-slider")}
                                    </span>
                                    <div className={"fields-wrapper inline"}>
                                        <ToggleSwitch
                                            initialValue={props.attributes.auto_slide_pause_on_hover}
                                            onChange={(value) => {
                                                props.updateAttributes({
                                                    auto_slide_pause_on_hover: value,
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </ProFeatureControl>
                )}

                {/* Auto Slide Controls for Triple Sliders */}
                {sliderType === "triple" && (
                    <ProFeatureControl {...props} value={"triple_auto_slide_enabled"}>
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Auto Slide", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <ToggleSwitch
                                    initialValue={props.attributes.triple_auto_slide_enabled || false}
                                    onChange={(value) =>
                                        props.updateAttributes({
                                            triple_auto_slide_enabled: value,
                                        })
                                    }
                                />
                                {!!props.proFeatureEnabled ? null : (
                                    <img
                                        src={coreAssets.icons.premium}
                                        alt="Premium Icon"
                                        style={{ marginTop: "-4px" }}
                                    />
                                )}
                            </div>
                        </div>

                        {props.attributes.triple_auto_slide_enabled && (
                            <>
                                <div className={"field-control field-inline"}>
                                    <span className="field-control__label">
                                        {__("Animation Duration (seconds)", "wp-before-after-image-slider")}
                                    </span>
                                    <div className={"fields-wrapper inline"}>
                                        <RangeControl
                                            initialPosition={6}
                                            trackColor="#4A25E1"
                                            railColor="#603CFF7A"
                                            max={10}
                                            min={1}
                                            step={0.5}
                                            value={parseFloat(props.attributes.triple_auto_slide_duration) || 6}
                                            onChange={(value) => props.updateAttributes({ triple_auto_slide_duration: value })}
                                        />
                                    </div>
                                </div>

                                <div className={"field-control field-inline"}>
                                    <span className="field-control__label">
                                        {__("Pause on Hover", "wp-before-after-image-slider")}
                                    </span>
                                    <div className={"fields-wrapper inline"}>
                                        <ToggleSwitch
                                            initialValue={ props.attributes.triple_auto_slide_pause_on_hover }
                                            onChange={(value) =>
                                                props.updateAttributes({
                                                    triple_auto_slide_pause_on_hover: value,
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </>
                        )}
                    </ProFeatureControl>
                )}
            </PanelRow>
        </PanelBody>
    );
};
